// extracted by css-extract-rspack-plugin
export default {"hint":"ControlsDialogHint-module__hint__iqTxXNU"};